import { Outlet } from "react-router-dom";

// Static gradient matching the app's dark theme - no heavy shader for stability
const STATIC_GRADIENT = 'linear-gradient(135deg, #6e0000 0%, #1e2239 50%, #000000 100%)';

export default function UserFlowLayout() {
  return (
    <div className="fixed inset-0" style={{ overscrollBehavior: 'none', background: STATIC_GRADIENT }}>
      {/* Page content rendered on top */}
      <div className="relative z-10 h-full overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
}
